import { useEffect, useState } from "react";
import { CheckBox } from "src/Components/Controls";
import { IconButton, Modal } from "src/Components";
import { SelectBox } from "src/UI";
import { Headline } from "src/UI";
import { IModalProps } from "..";
import { Select2WebElementType } from "src/Types/ReDoc";
import API from "src/API";
import "../modals.scss";
import "./RedirectModal.scss";

interface IRedirectModalProps extends IModalProps {};

/**
 * Модальное окно перенаправления посетителя
 * Позволяет перенаправить посетителя на другое окно с выбором приоритета
 */
const RedirectModal: React.FC<IRedirectModalProps> = ( { isOpen, onClose, onAction } ) => {

	const [ winNumber, setWinNumber ] = useState<string>("");
	const [ prior, setPrior ] = useState<string>("Default");
	const [ isRedirect, setIsRedirect ] = useState<boolean>(false);
	const [ stations, setStations ] = useState<Array<{ id: string; title: string }>>([]);

	/** Загружает список доступных окон при монтировании компонента */
	useEffect( () => {
		API.DamaskEQ.getStations()
			.then( data => {
				if ( !data.hasError ) {
					setStations( toOptions(data.result) );
				}
			});
	}, [] );

	/** Рендерит содержимое модального окна. Отображает селекты для выбора окна и приоритета, чекбокс для возврата */
	const renderBody: React.FC = ( props ) => (
		<div className="modal_wrapper modal_wrapper-redirect">
			<Headline>Выберите номер окна</Headline>
			<SelectBox
				options={stations}
				selectedValues={winNumber ? [winNumber] : []}
				onChangeSelected={(items) => setWinNumber(items[0]?.id ?? "")}
				placeholder="Выберите или введите номер окна"
				allowClear
			/>
			<Headline>Выберите приоритет вызова</Headline>
			<SelectBox
				options={PriorList}
				selectedValues={prior ? [prior] : []}
				onChangeSelected={(items) => setPrior(items[0]?.id ?? "")}
			/>
			<CheckBox value={isRedirect} setValue={setIsRedirect} name="save_acc" isBlock>Заявитель должен вернуться после обслуживания</CheckBox>
		</div>
	);

	/** Рендерит панель инструментов модального окна */
	const renderModalToolbar = () => {
		const payload = {
			window: +winNumber,
			priority: prior,
			callback: isRedirect
		};
		return (
			<>
				<IconButton outline onClick={onClose}>Закрыть</IconButton>
				<IconButton onClick={ () => onAction('redirect', payload )} >Перенаправить</IconButton>
			</>
		)
	};

	return (
		<Modal
			isOpen={isOpen}
			title="Перенаправить посетителя"
			onClose={onClose}
			color="light"
			className="not_scrolled"
			renderFooter={renderModalToolbar()}
			renderBody={renderBody}
		/>
	);
};

/** Список доступных приоритетов перенаправления */
const PriorList: Array<{ id: string; title: string }> = [
	{
		id: "Low",
		title: "Низкий (разместить в конец очереди)"
	},
	{
		id: "Default",
		title: "Cохранить прежний приоритет"
	},
	{
		id: "High",
		title: "Высокий (поместить в начало очереди)"
	}
];

/** Преобразует список окон из API в формат для SelectBox */
const toOptions = ( items: Select2WebElementType[] ): Array<{ id: string; title: string }> =>
    items.map( (item: Select2WebElementType) => ({
        id: item.id,
        title: item.text || item.id
    }));

export default RedirectModal;
